module.exports = __webpack_public_path__ + "media/images/Tap-1287c8e1.svg";